import React from 'react';
import { Box, FormControlLabel, Switch } from '@mui/material';
import { Warning } from '@mui/icons-material';

interface SimilarOnlySwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  labelFontSize?: string;
}

/**
 * Switch "Apenas similares" — idêntico nas 3 variantes de AdvancedFilters. Extraído de
 * AdvancedFilters.tsx (F7).
 */
export const SimilarOnlySwitch: React.FC<SimilarOnlySwitchProps> = ({
  checked,
  onChange,
  labelFontSize,
}) => {
  return (
    <FormControlLabel
      control={
        <Switch
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          onClick={(e) => {
            e.stopPropagation();
            onChange(!checked);
          }}
          size="small"
          sx={{
            '& .MuiSwitch-switchBase.Mui-checked': {
              color: 'warning.main',
            },
            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
              backgroundColor: 'warning.main',
            },
          }}
        />
      }
      label={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Warning sx={{ fontSize: 18, color: 'warning.main' }} />
          <span style={labelFontSize ? { fontSize: labelFontSize } : undefined}>Apenas similares</span>
        </Box>
      }
    />
  );
};

export default SimilarOnlySwitch;
